import { PayloadAction } from "@reduxjs/toolkit";
import { Page } from "../../../../../utl/models/Page";
import { UpsellState } from "../models/UpsellsState";

const setPageUpsells = (state: UpsellState, action: PayloadAction<Page>) => {
    state.page = action.payload.page;
}

export default setPageUpsells;